export default "__VITE_ASSET__A6g6mBsI__"